import { Backdrop, Fade } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import { type FC } from 'react';

import { useMiniBag } from '../../hooks';
import { MiniBag } from '../MiniBag';
import { ModalRoot, NonModalRoot } from './styles';
import type { MiniBagWrapperProps } from './types';

export const MiniBagWrapper: FC<MiniBagWrapperProps> = (props) => {
  const { getTestId } = useTestId();
  const { isOpenedMinibagOnDesktop, isVisible, handleOverlayClick, minibagProps, ownerState } = useMiniBag(props);

  if (isOpenedMinibagOnDesktop) {
    return (
      <NonModalRoot>
        <Fade in={isVisible}>
          <div data-testid={getTestId('fading-wrapper')}>
            <MiniBag {...minibagProps} />
          </div>
        </Fade>
      </NonModalRoot>
    );
  }

  return (
    <ModalRoot
      disableEnforceFocus
      disablePortal
      ownerState={ownerState}
      open={isVisible}
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          onClick: handleOverlayClick,
        },
      }}
    >
      <Fade in={isVisible}>
        <div data-testid={getTestId('fading-wrapper')}>
          <MiniBag {...minibagProps} />
        </div>
      </Fade>
    </ModalRoot>
  );
};
